import { AuthModel } from './_models'
import { KEY_LOCALSTORAGE } from './_consts';
import { getServiceConfiguration } from './_requests';
import axios from 'axios';

export const handleGetServiceConfiguration = async () => {
  let lsValue: any = { "ssoUrl": process.env.REACT_APP_API_URL_SSO, "apiUrl": process.env.REACT_APP_API_URL, "adminUrl": process.env.REACT_APP_XADMIN_ENDPOINT };
  try {
    let respone = await getServiceConfiguration();

    let lsValueRes: any;
    if (typeof respone.data?.data === 'string') {
      lsValueRes = JSON.parse(respone.data.data);
    } else if (typeof respone.data?.data === 'object') {
      lsValueRes = respone.data.data;
    } else {
      console.error("Unexpected service configuration format:", respone.data?.data);
      lsValueRes = {};
    }

    Object.keys(lsValueRes).forEach((key: string) => {
      lsValue[key] = lsValueRes[key] ?? (lsValue[key] ?? "");
    });

    // Get general configuration from /tenants/config
    try {
      const SSO_URL = lsValue.ssoUrl || process.env.REACT_APP_API_URL_SSO;
      const lsAuth: string | null = localStorage.getItem('kt-auth-react-v')
      const auth: AuthModel | null = lsAuth ? JSON.parse(lsAuth) : null;

      if (auth?.access_token) {
        const generalConfigResponse = await axios.get(`${SSO_URL}/tenants/config`);

        if (generalConfigResponse.data?.data) {
          let generalConfig: any;
          if (typeof generalConfigResponse.data.data === 'string') {
            generalConfig = JSON.parse(generalConfigResponse.data.data);
          } else if (typeof generalConfigResponse.data.data === 'object') {
            generalConfig = generalConfigResponse.data.data;
          } else {
            generalConfig = {};
          }

          const tenantLevelKeys = ['poweredBy', 'applicationName', 'homeTextColor', 'appDocumentTitle'];
          tenantLevelKeys.forEach((key: string) => {
            if (generalConfig[key] !== null && generalConfig[key] !== undefined) {
              lsValue[key] = generalConfig[key];
            }
          });
        }
      }
    } catch (generalConfigError) {
      console.error("Error fetching general configuration:", generalConfigError);
    }

    if (lsValue) localStorage.setItem(KEY_LOCALSTORAGE.CONFIGURATION, JSON.stringify(lsValue));
  } catch (error) {
    console.error("ERROR", error);
    localStorage.setItem(KEY_LOCALSTORAGE.CONFIGURATION, JSON.stringify(lsValue));
  }
};
